import { render, staticRenderFns } from "./fifty_notes.vue?vue&type=template&id=621bd53a&scoped=true"
import script from "./fifty_notes.vue?vue&type=script&lang=js"
export * from "./fifty_notes.vue?vue&type=script&lang=js"
import style0 from "./fifty_notes.vue?vue&type=style&index=0&id=621bd53a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621bd53a",
  null
  
)

export default component.exports